import styles from './SectionPedidosCadastrados.module.scss';
import { useState } from "react";
import { IPedido } from "../../../interfaces/pedido.interface"
import CardPedido from "../../Cards/CardPedido";
import PedidoDeCompra from "../../PedidoPDF";
import useDeletePedido from '../../../hooks/pedidos/useDeletePedido';
import useDeleteItemPedido from '../../../hooks/itemPedido/useDeleteItemPedido';
import useFetchItensPedido from '../../../hooks/itemPedido/useFetchItensPedido';

interface Props {
    pedidos: IPedido[];
}

export default function SectionPedidosCadastrados({ pedidos }: Props) {
    const [selectedPedido, setSelectedPedido] = useState<string>('');
    const { deletePedido } = useDeletePedido();
    const { itens } = useFetchItensPedido();
    const { deleteItemPedido } = useDeleteItemPedido();
    const [click, setClick] = useState<boolean>(true);

    const excluir = async (pedido: IPedido) => {
        const itensDoPedido = itens.filter(item => item.pedidoId === pedido.id)
        for (const item of itensDoPedido) {
            if (item.id !== undefined) {
                await deleteItemPedido(item.id);
            }
        }
        if (pedido.id !== undefined) { await deletePedido(pedido.id) };
    }

    return (
        <section className={styles.container}>
            <h1>Pedidos cadastrados: </h1>

            <div className={styles.containerCards}>
                {pedidos.map((pedido: IPedido) => (
                    <div key={pedido.id}>
                        <CardPedido
                            pedido={pedido}
                            detalhes={() => pedido.id && setSelectedPedido(pedido.id)}
                            excluir={() => excluir(pedido)}
                        />

                        {selectedPedido === pedido.id &&
                            <PedidoDeCompra pedido={pedido} voltar={() => setSelectedPedido('')} />
                        }
                    </div>
                ))}
            </div>
        </section>
    );
}
